import { OrganTypeBadge } from '@ui';
import { OrganType } from '@/api/apis/case';

type OrganSpecializationsListProps = {
  organs: OrganType[];
  size?: 'sm' | 'md' | 'lg';
  bgTone?: 'bg40' | 'bg50' | 'bg60';
  className?: string;
};

export const OrganSpecializationsList = ({
  organs,
  size = 'md',
  bgTone = 'bg50',
  className = '',
}: OrganSpecializationsListProps) => (
  <div className={`flex gap-1 items-center ${className}`}>
    {organs.map((organ) => (
      <OrganTypeBadge key={organ} organ={organ} size={size} bgTone={bgTone} />
    ))}
  </div>
);
